import { useMemo } from 'react'
import { useMatches } from 'react-router-dom'
import { getRoutes, type RouteKey, getRouteById, type RouteById, type RouteId } from '../routing/routes'

const routes = getRoutes()

export const useRouteData = () => {
  const matches = useMatches()
  const matchData = useMemo(() => {
    const ids = matches.map(route => route.id) as RouteKey[]
    return routes.filter(route => ids.includes(route.id))
  }, [matches])
  return matchData
}

export const useRouteMatchChecker = () => {
  const matches = useMatches()
  return (routeId: RouteKey) => matches.some(route => route.id === routeId)
}

export const useIsRoute = (routeId: RouteKey) => {
  const matches = useMatches()
  return useMemo(() => matches.some(route => route.id === routeId), [matches, routeId])
}

export const useRouteById = <IdType extends RouteId>(routeId: IdType): RouteById<IdType> => {
  return getRouteById(routeId)
}
